var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext, useState } from "react";
import { useQuery } from "@apollo/client";
import { Alert, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField, } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
import { GET_INITIALIZATION_COUNTRIES, GET_INITIALIZATION_CONTESTS, GET_INITIALIZATION_STYLES, } from "@/queries/GetInitializationCountries";
import { initializationCountries, initializationAreaIds, } from "./initializationCountries";
export var InitializationCountryDialog = function (_a) {
    var _b, _c;
    var electionEventId = _a.electionEventId, electionId = _a.electionId, busy = _a.busy, _d = _a.snapshots, snapshots = _d === void 0 ? [] : _d, onClose = _a.onClose, onGenerate = _a.onGenerate;
    var t = useTranslation().t;
    var _e = useState(""), country = _e[0], setCountry = _e[1];
    var hasRole = useContext(AuthContext).hasRole;
    var roleFor = function (permission) {
        return hasRole(permission)
            ? permission
            : hasRole(IPermissions.ADMIN_USER)
                ? IPermissions.ADMIN_USER
                : null;
    };
    var areaRole = roleFor(IPermissions.AREA_READ);
    var contestRole = roleFor(IPermissions.CONTEST_READ);
    var styleRole = roleFor(IPermissions.PUBLISH_READ);
    var areaQuery = useQuery(GET_INITIALIZATION_COUNTRIES, {
        variables: { electionEventId: electionEventId },
        context: { headers: { "x-hasura-role": areaRole } },
        skip: !areaRole,
        fetchPolicy: "network-only",
    });
    var contestQuery = useQuery(GET_INITIALIZATION_CONTESTS, {
        variables: { electionEventId: electionEventId, electionId: electionId },
        context: { headers: { "x-hasura-role": contestRole } },
        skip: !contestRole,
        fetchPolicy: "network-only",
    });
    var styleQuery = useQuery(GET_INITIALIZATION_STYLES, {
        variables: { electionEventId: electionEventId, electionId: electionId },
        context: { headers: { "x-hasura-role": styleRole } },
        skip: !styleRole,
        fetchPolicy: "network-only",
    });
    var loading = areaQuery.loading || contestQuery.loading || styleQuery.loading;
    var error = areaQuery.error ||
        contestQuery.error ||
        styleQuery.error ||
        !areaRole ||
        !contestRole ||
        !styleRole;
    var data = areaQuery.data && contestQuery.data && styleQuery.data
        ? {
            sequent_backend_area: areaQuery.data.sequent_backend_area,
            sequent_backend_area_contest: areaQuery.data.sequent_backend_area_contest.map(function (link) {
                var _a, _b;
                return ({
                    area_id: link.area_id,
                    contest: (_b = (_a = contestQuery.data) === null || _a === void 0 ? void 0 : _a.sequent_backend_contest.find(function (_a) {
                        var id = _a.id;
                        return id === link.contest_id;
                    })) !== null && _b !== void 0 ? _b : null,
                });
            }),
            sequent_backend_ballot_style: styleQuery.data.sequent_backend_ballot_style,
        }
        : undefined;
    var countries = data ? initializationCountries(data, electionId, snapshots) : [];
    var published = snapshots.find(function (entry) { return entry.election_id === null || entry.election_id === electionId; });
    var knownEmpty = ((_c = (_b = published === null || published === void 0 ? void 0 : published.snapshot.initialization_countries) === null || _b === void 0 ? void 0 : _b[electionId]) === null || _c === void 0 ? void 0 : _c.length) === 0;
    var canGenerate = countries.length > 0 || knownEmpty;
    var selectionValid = !country || countries.some(function (area) { return area.id === country; });
    var generate = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (busy || loading || error || !canGenerate || !selectionValid)
                        return [2 /*return*/];
                    return [4 /*yield*/, onGenerate(countries.length ? initializationAreaIds(country, countries) : undefined)];
                case 1:
                    if (_a.sent())
                        onClose();
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(Dialog, { open: true, onClose: busy ? undefined : onClose, fullWidth: true, maxWidth: "sm", children: [_jsx(DialogTitle, { children: t("publish.action.generateInitializationReport") }), _jsxs(DialogContent, { children: [_jsx(Alert, { severity: "info", sx: { mb: 2 }, children: t("publish.initialization.countryInfo") }), loading ? (_jsx(CircularProgress, { size: 24 })) : error ? (_jsx(Alert, { severity: "error", children: t("publish.initialization.countriesError") })) : !canGenerate ? (_jsx(Alert, { severity: "error", children: t("publish.initialization.noCountries") })) : (_jsxs(TextField, { select: true, fullWidth: true, label: t("publish.initialization.country"), SelectProps: { displayEmpty: true }, InputLabelProps: { shrink: true }, value: country, onChange: function (event) { return setCountry(event.target.value); }, disabled: busy, children: [_jsx(MenuItem, { value: "", children: t("publish.initialization.entirePost") }), countries.map(function (area) { return (_jsx(MenuItem, { value: area.id, children: area.name || area.id }, area.id)); })] }))] }), _jsxs(DialogActions, { children: [_jsx(Button, { onClick: onClose, disabled: busy, children: t("common.label.cancel") }), _jsx(Button, { onClick: generate, disabled: busy || loading || !!error || !canGenerate || !selectionValid, children: busy ? (_jsx(CircularProgress, { size: 16 })) : (t("publish.action.generateInitializationReport")) })] })] }));
};
